import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

const ProjectCard = ({ title, description, technologies, link, type, logo }) => {
  return (
    <div className="bg-white border border-gray-100 shadow-lg rounded-md p-6 text-center transition-transform transform hover:scale-105">
      {logo && (
        <img
          src={logo}
          alt={`${title} Logo`}
          className="mx-auto mb-4 h-20 w-auto object-contain rounded-2xl"
        />
      )}
      <h3 className="text-xl font-bold mb-2">{title}</h3>
      <p className="text-gray-600 mb-4">{description}</p>
      <div className="flex flex-wrap justify-center gap-2 mb-4">
        {technologies.map((tech, index) => (
          <span
            key={index}
            className="bg-blue-100 text-blue-800 text-sm font-medium px-3 py-1 rounded-full"
          >
            {tech}
          </span>
        ))}
      </div>
      <a
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        className="text-blue-600 underline flex items-center justify-center gap-2 hover:text-blue-800"
      >
        View {type === 'App' ? 'on the App Store' : 'Website'}
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
      </a>
    </div>
  );
};

export default ProjectCard;
